import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'itl-button',
  template: '<ng-content></ng-content>',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ButtonComponent implements OnChanges {
  // Set to "block" for a full-width with left and right borders.
  @Input() expand: 'block' | undefined;
  @Input() disabled = false;
  @Input() color: 'secondary' | 'primary' = 'primary';
  @Input() squareSize: number | undefined;

  @HostBinding('class.displayBlock') displayBlock = false;
  @HostBinding('class.disabled') disabledStyle = false;
  @HostBinding('class.colorSecondary') colorSecondary = false;
  @HostBinding('style.min-width') get minWidth() {
    return this.squareSize ? `${this.squareSize}px` : null;
  }
  @HostBinding('style.min-height') get minHeight() {
    return this.squareSize ? `${this.squareSize}px` : null;
  }
  @HostBinding('style.padding') get squarePadding() {
    return this.squareSize ? '0' : null;
  }
  @HostBinding('style.margin') get squareMargin() {
    return this.squareSize ? '0' : null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.displayBlock = this.expand === 'block';
    this.disabledStyle = this.disabled;
    this.colorSecondary = this.color === 'secondary';
  }
}
